/* eslint-disable no-param-reassign */
import getLangCodeForRegion from './getLangCodeForRegion';

export const getLangForLocale = locale => getLangCodeForRegion(locale.split('-')[1]);

export const formatDate = (date, lang, formatOptions = {}) => {
  const { quarter = false, ...options } = formatOptions;
  let result;

  const langForRegion = getLangForLocale(lang);
  const dateTimeFormat = Intl.DateTimeFormat(langForRegion, options);

  if (dateTimeFormat.formatToParts) {
    result = dateTimeFormat.formatToParts(date).map((part) => {
      const parsedLang = lang.split('-')[0];

      if (part.type === 'month') {
        part.value = Intl.DateTimeFormat(parsedLang, { month: options.month }).format(date);
      }

      if (part.type === 'weekday') {
        part.value = Intl.DateTimeFormat(parsedLang, { weekday: options.weekday }).format(date);
      }

      return part.value;
    }).join('');
  } else {
    result = dateTimeFormat.format(date);
  }

  if (quarter) {
    result = `${Math.ceil((date.getMonth() + 1) / 4)} ${result}`;
  }

  return result;
};

export default formatDate;
